var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53 53",
    style: {
      enableBackground: "new 0 0 53 53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.7,31.9L51.7,31.9c0,0.1,0,0.2,0,0.2l0,0c-2.9,12-12.8,20.3-25.3,20.3c-6.6,0-13-2.6-17.8-7.2l-4.4,4.4 c-0.4,0.4-0.9,0.6-1.5,0.6l0,0c-1.2,0-2.2-1-2.2-2.2V33c0-1.2,1-2.2,2.2-2.2h15.2c1.2,0,2.2,1,2.2,2.2l0,0c0,0.6-0.2,1.1-0.6,1.5 l0,0l-4.6,4.6c3.1,2.9,7.2,4.7,11.8,4.7c6.2,0,11.6-3.3,14.7-8.2v-0.1c0.8-1.3,1.2-2.6,1.8-4c0.2-0.5,0.5-0.8,1-0.8h6.5 C51.2,30.8,51.6,31.3,51.7,31.9L51.7,31.9L51.7,31.9z M52.5,4.8V20c0,1.2-1,2.2-2.2,2.2H35.2c-1.2,0-2.2-1-2.2-2.2l0,0 c0-0.6,0.2-1.1,0.6-1.5l0,0l4.7-4.7c-3.1-2.9-7.2-4.6-11.8-4.6c-6.2,0-11.7,3.3-14.7,8.2v0.1c-0.8,1.3-1.2,2.6-1.8,4 c-0.2,0.5-0.5,0.8-1,0.8H2.2c-0.6,0-1.1-0.5-1.1-1.1V21C4,8.8,14,0.5,26.5,0.5c6.6,0,13.1,2.6,17.9,7.2l4.4-4.4 c0.4-0.4,0.9-0.6,1.5-0.6l0,0C51.5,2.7,52.5,3.6,52.5,4.8L52.5,4.8L52.5,4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSpinner);
export default __webpack_public_path__ + "static/media/modalSpinner.141d28c69d4bc3926adf1800b71dbd89.svg";
export { ForwardRef as ReactComponent };